<template>
	<b-modal ref="modal" noPadding auto huge>
		<div slot="header" class="display-flex align-items-center margin-normal">
			<div class="">
				<b-button link @clickOrEnter="handlePreviousClick()" class="padding-0 margin-right-tiny">
					<b-icon class="ink-lighter-1">
						<icon-chevron-left class="font-size-huge" />
					</b-icon>
				</b-button>
				<b-button link @clickOrEnter="handleNextClick()" class="padding-0 margin-right-normal">
					<b-icon class="ink-lighter-1">
						<icon-chevron-right class="font-size-huge" />
					</b-icon>
				</b-button>
			</div>

			<span v-if="images.length && images[currentIndex].title" class="font-size-xxbig semi-bold">{{
				images[currentIndex].title
			}}</span>
		</div>

		<img
			v-if="images.length && images[currentIndex].title && images[currentIndex].url"
			:src="images[currentIndex].url"
			:alt="images[currentIndex].title"
			:class="['image', { 'image-no-footer': !footer }]"
			@click="handleNextClick()"
		/>

		<div
			v-if="footer"
			class="display-flex justify-content-between font-size-big margin-horizontal-normal margin-vertical-tiny"
		>
			<b-button link class="font-size-big padding-0 margin-right-normal">
				<b-icon class="">
					<icon-cloud-download />
				</b-icon>
				Download
			</b-button>
			<span>Imagem {{ currentIndex + 1 }} de {{ images.length }}</span>
		</div>
	</b-modal>
</template>

<script>
import BModal from '../components/Modal.vue';
import BButton from '../components/Button.vue';
import BIcon from '../components/Icon.vue';
import IconChevronLeft from '../icons/icon-chevron-left.svg';
import IconChevronRight from '../icons/icon-chevron-right.svg';
import IconCloudDownload from '../icons/icon-cloud-download.svg';

export default {
	name: 'b-lightbox',
	components: {
		BModal,
		BButton,
		BIcon,
		IconChevronLeft,
		IconChevronRight,
		IconCloudDownload
	},
	props: {
		/*
		 * Se true mostra o footer
		 */
		footer: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			images: [],
			currentIndex: 0
		};
	},
	mounted() {
		this.currentIndex = this.currentImageIndex;
	},
	methods: {
		hideModal() {
			return this.$refs.modal.hideModal();
		},
		toggleModal() {
			return this.$refs.modal.toggleModal();
		},
		showModal(images, index) {
			this.images = images;
			this.currentIndex = index;

			return this.$refs.modal.showModal();
		},
		handlePreviousClick() {
			this.currentIndex = (this.currentIndex + this.images.length - 1) % this.images.length;
		},
		handleNextClick() {
			this.currentIndex = (this.currentIndex + 1) % this.images.length;
		}
	}
};
</script>

<style scoped lang="scss">
.image {
	max-width: 100%;
	max-height: 75vh;
}
.image-no-footer {
	border-bottom-right-radius: 5px;
	border-bottom-left-radius: 5px;
	margin-bottom: -2px;
}
</style>

<docs>
    Lightbox
</docs>
